module.exports = __webpack_public_path__ + "media/customer_tickets/casino-ada154d6.svg";